import { styled } from '@mui/material';

export const Root = styled('span')({
  // whiteSpace: 'nowrap',
});

export const PreviousPrice = styled('span')({
  textDecoration: 'line-through',
});
